import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

const Package = ({ refProp, value, showDetails, formulaSelected, children }) => (
  <div className={cn('flex-grid padding-grid', { selected_item: refProp === formulaSelected })}>
    {showDetails === true && children}
    {showDetails !== true && (
      <div style={{ height: '100%' }} className="flex-grid-center-vertical flex-grid-center-horizontal">
        <span>{value}</span>
      </div>
    )}
  </div>
);

Package.propTypes = {
  refProp: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  showDetails: PropTypes.bool,
  formulaSelected: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

Package.defaultProps = {
  showDetails: false,
  formulaSelected: undefined,
};

export default Package;
